module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_NUTERGIA.a81431e0.png";